import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Mail, MapPin, Phone, Linkedin } from "lucide-react";
import api from "@/lib/api";

export default function Footer() {
  const [contact, setContact] = useState({ phone: "07 81 81 09 14", email: "contact@besson-solutions.fr" });
  useEffect(() => {
    api.get("/settings/public").then((r) => {
      const d = r.data || {};
      setContact({
        phone: d.contact_phone || "07 81 81 09 14",
        email: d.contact_email || "contact@besson-solutions.fr",
      });
    }).catch(() => {});
  }, []);
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A1128] text-white pt-20 pb-10 overflow-hidden grain">
      <div className="absolute -top-24 -left-20 w-96 h-96 blob-turquoise opacity-30" />
      <div className="absolute -bottom-32 right-0 w-[28rem] h-[28rem] blob-peach opacity-20" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="https://customer-assets.emergentagent.com/job_business-mvp-1/artifacts/c6kygdj0_BESSON-footer.png"
            alt="BESSON SOLUTIONS"
            className="w-44 sm:w-52 mb-6"
            data-testid="footer-logo"
          />
          <p className="text-white/70 max-w-md text-[15px] leading-relaxed">
            Identité, stratégie, outils métier, développement commercial et accompagnement licences & franchises.
            <br />Un seul partenaire pour faire grandir votre activité.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <span className="text-xs uppercase tracking-[0.2em] text-white/40">Zones</span>
            <span className="text-[13px] text-white/80">Sud-Est · France · DOM-TOM · Corse</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="display text-sm uppercase tracking-[0.2em] text-[#67E8F9] mb-4">Navigation</h4>
          <ul className="space-y-2 text-white/80 text-[14px]">
            <li><a href="/#services" className="hover:text-[#67E8F9]">Services</a></li>
            <li><Link to="/qui-sommes-nous" className="hover:text-[#67E8F9]">Qui sommes-nous</Link></li>
            <li><Link to="/etudes-de-cas" className="hover:text-[#67E8F9]">Études de cas</Link></li>
            <li><Link to="/rendez-vous" className="hover:text-[#67E8F9]">Prendre RDV en ligne</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-[#67E8F9]">Mentions légales</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="display text-sm uppercase tracking-[0.2em] text-[#67E8F9] mb-4">Contact</h4>
          <ul className="space-y-3 text-white/85 text-[14px]">
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#67E8F9]" /> <a href={`mailto:${contact.email}`} className="hover:text-[#67E8F9]">{contact.email}</a></li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-[#67E8F9]" /> <a href={`tel:${contact.phone.replace(/\s+/g, "")}`} className="font-bold tabular-nums hover:text-[#67E8F9]">{contact.phone}</a></li>
            <li className="flex items-center gap-3"><MapPin size={16} className="text-[#67E8F9]" /> Istres, Sud-Est de la France · interventions partout en France</li>
          </ul>
        </div>
      </div>

      <div className="relative mt-16 pt-6 border-t border-white/10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/50 text-xs">
        <span>© {new Date().getFullYear()} BESSON SOLUTIONS — Tous droits réservés</span>
        <div className="flex flex-wrap items-center gap-4">
          <Link to="/cgv" data-testid="footer-cgv" className="hover:text-[#67E8F9] transition-colors">CGV</Link>
          <Link to="/mentions-legales" data-testid="footer-mentions" className="hover:text-[#67E8F9] transition-colors">Mentions légales</Link>
          <Link to="/confidentialite" data-testid="footer-confidentialite" className="hover:text-[#67E8F9] transition-colors">Confidentialité</Link>
        </div>
      </div>
    </footer>
  );
}
